var exports = {
  "Ke": "xdbfd91f1--256910--no_image",
  "SB": "xdbfd91f1--256910--no_image-icon",
  "wv": "xdbfd91f1--256910--no_image-text",
};

module.exports = exports;
